import { render, staticRenderFns } from "./GratisExpiradosCard.vue?vue&type=template&id=94df7be0"
import script from "./GratisExpiradosCard.vue?vue&type=script&lang=ts"
export * from "./GratisExpiradosCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports